
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cee-exam",
      function () {
        return require("private-next-pages/cee-exam.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cee-exam"])
      });
    }
  